export default "__VITE_ASSET__DxRGhMll__"